<span [ngSwitch]="value">
  <span class="badge bg-danger" *ngSwitchCase="'CREDIT'"> {{'employeePaymentTransactionTypeValue.'+value | translate}}</span>
  <span class="badge bg-success" *ngSwitchCase="'DEBIT'"> {{'employeePaymentTransactionTypeValue.'+value | translate}}</span>
  <span class="badge bg-info" *ngSwitchDefault>
    <span *ngIf="value">
      {{'employeePaymentTransactionTypeValue.'+value | translate}}</span>

  </span>
</span>